import { Injectable, Injector } from '@angular/core';
import { BitfApiService } from '@bitf/services/api/bitf-api.service';
import { Observable } from 'rxjs';
import { IBitfApiResponse, IBitfApiRequest } from '@interfaces';
import { BitfFormItemConfig } from '@models';

import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class CalendarEventsService extends BitfApiService {
  constructor(public injector: Injector) {
    super('splist/calendar-events', injector);
    // super('splist/calendar-events', injector, environment.mockApiUrl, 'mockDbParser');
  }

  getFormItemConfig(): Observable<IBitfApiResponse<BitfFormItemConfig>> {
    return super.request({
      method: 'GET',
      path: '/form-items-config',
      modelMapper: 'form-items-config',
      // apiUrl: environment.mockApiUrl,
      // apiParser: 'mockDbParser',
    } as IBitfApiRequest);
  }
}
